import { jsx } from "react/jsx-runtime";
import { RouterProvider } from "@tanstack/react-router";
import { afterHydrate } from "./serialization.js";
let cleaned = false;
function StartClient(props) {
  var _a;
  if (!props.router.state.matches.length) {
    props.router.hydrate();
    afterHydrate({ router: props.router });
  }
  if (!cleaned) {
    cleaned = true;
    (_a = window.__TSR__) == null ? void 0 : _a.cleanScripts();
  }
  return /* @__PURE__ */ jsx(RouterProvider, { router: props.router });
}
export {
  StartClient
};
//# sourceMappingURL=StartClient.js.map
